export default __webpack_public_path__ + "static/media/login.f7cfbf92.png";